import type { DocumentUiStatus } from '../types/document';

const labels: Record<DocumentUiStatus, string> = {
  uploading: 'Uploading',
  'upload-interrupted': 'Upload interrupted',
  learning: 'Learning',
  ready: 'Ready',
  'no-evidence': 'No clear evidence',
  'needs-review': 'Needs review',
  failed: 'Failed',
  removing: 'Updating memory',
  'removal-retrying': 'Retrying update',
  'removal-attention': 'Needs attention',
  removed: 'Removed',
};

export function DocumentStatusBadge({ status }: { status: DocumentUiStatus }) {
  return <span className={`r42-document-status r42-document-status--${status}`}>{labels[status]}</span>;
}
